export default function WebSocketReadCard(ws, msg, successCallBack, failCallBack) {

  ws.onerror = (errorEvent) => {
    // console.log('--ws.onerror --', errorEvent)

    failCallBack({ state: ws.readyState })
  }

  ws.onmessage = (messageEvent) => {
    var jsonObject = JSON.parse(messageEvent.data)

    if (jsonObject.Ret !== 0) {
      failCallBack({ message: jsonObject.ErrInfo, state: ws.readyState })
      return
    }
    const cardInfoBase64 = JSON.parse(window.atob(jsonObject.UserParam))

    let res = {}
    // 身份证信息
    if (jsonObject.Cmd === 10001) {
      res = {
        name: hex2a(window.atob(cardInfoBase64.CardInfo.Name)).trim(),
        idNumber: hex2a(window.atob(cardInfoBase64.CardInfo.No)).trim(),
        sex: Number(hex2a(window.atob(cardInfoBase64.CardInfo.Sex))),
        nation: Number(hex2a(window.atob(cardInfoBase64.CardInfo.Nation))),
        birthday: hex2a(window.atob(cardInfoBase64.CardInfo.Birthday)).trim(),
        address: hex2a(window.atob(cardInfoBase64.CardInfo.Address)).trim(),
        department: hex2a(window.atob(cardInfoBase64.CardInfo.SignedDepartment)).trim(),
        begin: hex2a(window.atob(cardInfoBase64.CardInfo.ValidityPeriodBegin)).trim(),
        end: hex2a(window.atob(cardInfoBase64.CardInfo.ValidityPeriodEnd)).trim(),
        image: cardInfoBase64.BmpInfo
      }
    }
    // IC 卡号
    if (jsonObject.Cmd === 30401) {
      res = {
        number: cardInfoBase64.SN
      }
    }
    successCallBack(res)
  }

  if (ws.readyState === 1) {
    try {
      sendWebSocketMsg(ws, msg)
    } catch (error) {
      failCallBack({ ...error, state: ws.readyState })
    }
  } else {
    ws.onopen = () => { sendWebSocketMsg(ws, msg) }
  }
}
function sendWebSocketMsg (ws, msg) {
  // console.log('--sendWebSocketMsg--', ws.readyState)
  let szJson = '{"Cmd":10000,"Head":"YZWL","IPFlag":"MGEyZmU1NmY5ODZlZGMyNg==","UserParam":"eyJBcHBLZXkiOiI5OWZmYjJmOThhMjkwNzExMDdjN2EwOWFkMmM2ZDA5NiIsIkRlY29kZVBob3RvIjp0cnVlLCJGYWNlQ29tcGFyZSI6ZmFsc2UsIlBob3RvRm9ybWF0IjoxLCJTZXJ2ZXJJUCI6ImlkLnl6ZnV0dXJlLmNuIiwiU2VydmVyUG9ydCI6ODg0OH0NCg==","Version":"V1.0.0"}\n'
  ws.send(msg || szJson)
}

function hex2a(hex) {
  let strList = ''
  for (var i = 0;
    (i < hex.length && hex.substr(i, 2) !== '00'); i += 2) {
    var c = hex.charCodeAt(i + 1) * 256 + hex.charCodeAt(i)
    strList += String.fromCharCode(c)
  }
  return strList.toString()
}
